/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useState, useEffect, useCallback, useContext} from 'react'

import {useRouter} from 'next/router'
import TruckLineIcon from 'remixicon-react/TruckLineIcon'
import styled from 'styled-components'
import {media} from 'styled-bootstrap-grid'

import {theme} from 'src/themes'
import {paths} from 'src/utils/paths'
import {formatNumber} from 'src/utils/numbers'
import {restApi} from 'src/api/rest'

import {SpacingWrapper} from 'src/components/layout'
import {Button} from 'src/components/buttons'
import {P} from 'src/components/typography'

import {
  handleCheckoutError,
  useCheckout,
  CheckoutContext,
} from 'src/context/CheckoutContext'

import {isNotNull} from 'src/utils/isNotNull'
import CheckoutRadioCard from './CheckoutRadioCard'
import {DeliveryNote} from './DeliveryNote'
import {CartShipmentPricingAlert} from '../cart/CartShipmentPricingAlert'

const droppMethodId = process?.env?.NEXT_PUBLIC_DROP_SHIPPING_METHOD_ID || ''
const droppDelMethodId = process?.env?.NEXT_PUBLIC_DROP_DELIVERY_METHOD_ID || ''

const IndentWrapper = styled.div`
  ${media.md`
    padding-left: 56px;
  `}
`

export default function Delivery(): JSX.Element {
  const {
    updateShippingMethod,
    checkout,
    prepareOrderCreate,
    prepareDroppOrderCreate,
  } = useCheckout()
  const {push} = useRouter()

  const {locationId, extLocationId, updateLocationId} =
    useContext(CheckoutContext) || {}

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [selectedShippingId, setSelectedShippingId] = useState<string>()
  const [note, setNote] = useState<string>(checkout ? checkout.note : '')
  const [shippingCost, setShippingCost] = useState<number | null>()
  const [droppLocations, setDroppLocations] = useState<any[]>([])
  const [droppDeliveryLocations, setDroppDeliveryLocations] = useState<any[]>(
    [],
  )
  const [locationInfo, setLocationInfo] = useState<any>('')

  const [availableShippingMethods, setAvailableShippingMethods] = useState<any>(
    checkout?.availableShippingMethods,
  )

  useEffect(() => {
    const droppNotAvailable: any = checkout?.lines?.filter((prod) =>
      prod?.variant.product.metadata.find(
        (item) =>
          item?.key === 'has_no_dropp_shipping' && item?.value === 'true',
      ),
    )
    if (droppNotAvailable.length > 0) {
      setAvailableShippingMethods(() =>
        availableShippingMethods.filter(
          (method: any) =>
            method.id !== droppMethodId && method.id !== droppDelMethodId,
        ),
      )
    }
  }, [checkout])

  const setLocationIdInfo = (location: any) => {
    if (updateLocationId) {
      updateLocationId(location)
    }
  }

  const onClickNext = useCallback(async () => {
    setIsLoading(true)

    if (!selectedShippingId) {
      return
    }

    if (note) {
      const noteJsonString = {
        note,
        locationInfo,
        // locationId,
        method:
          selectedShippingId === droppMethodId ||
          selectedShippingId === droppDelMethodId
            ? locationInfo
            : '',
      }
      await prepareOrderCreate(JSON.stringify(noteJsonString))
    }

    if (
      extLocationId &&
      (selectedShippingId === droppMethodId ||
        selectedShippingId === droppDelMethodId)
    ) {
      await prepareDroppOrderCreate(JSON.stringify({location: extLocationId}))
    }

    updateShippingMethod(selectedShippingId).then((res) => {
      const errors = res?.data?.checkoutShippingMethodUpdate?.errors
      if (!errors?.length) {
        push(paths.payment)
        setIsLoading(false)
      } else {
        handleCheckoutError(errors)
        setIsLoading(false)
      }
    })
  }, [
    note,
    updateShippingMethod,
    selectedShippingId,
    prepareOrderCreate,
    prepareDroppOrderCreate,
    push,
    locationInfo,
    extLocationId,
  ])

  const getLocations = useCallback(async () => {
    if (checkout?.shippingAddress?.postalCode) {
      const postalCode = checkout?.shippingAddress?.postalCode

      try {
        const {data}: any = await restApi.fetchDroppLocations(postalCode)
        if (data?.locations && postalCode) {
          setDroppLocations(data.locations)
        }
      } catch (err) {
        console.log('error', err)
      }
    }
  }, [])

  const getDeliveryLocations = useCallback(() => {
    if (checkout?.shippingAddress?.postalCode) {
      const postalCode = checkout?.shippingAddress?.postalCode
      restApi
        .fetchDroppDeliveryLocations(postalCode)
        .then(({data}: any) => {
          if (data?.codes) {
            setDroppDeliveryLocations(data?.codes.map((code: any) => code.code))
          }
        })
        .catch((err) => {
          console.log('error', err)
          return false
        })
    }
    return []
  }, [])

  useEffect(() => {
    getLocations()
    getDeliveryLocations()
  }, [getDeliveryLocations, getLocations])

  useEffect(() => {
    const methodId = checkout?.shippingMethod?.id
    if (checkout && methodId === droppMethodId) {
      getLocations()
    }
  }, [checkout, getLocations])

  useEffect(() => {
    const availableMethods = checkout?.availableShippingMethods
    if (selectedShippingId === droppMethodId) {
      setShippingCost(null)
    } else if (selectedShippingId === droppDelMethodId) {
      setShippingCost(null)
    } else if (checkout?.availableShippingMethods) {
      const rules = availableMethods?.find(
        (method) => method?.postalCodeRules?.length,
      )
      rules?.postalCodeRules?.map((rule: any): null => {
        if (
          checkout?.shippingAddress?.postalCode &&
          checkout?.shippingAddress?.postalCode <= rule.end &&
          checkout?.shippingAddress?.postalCode >= rule.start
        ) {
          setShippingCost(() =>
            rules.maximumOrderPrice === null
              ? rules.minimumOrderPrice?.amount
              : rules.maximumOrderPrice?.amount,
          )
        }
        return null
      }, [])
    }
  }, [checkout, selectedShippingId])

  useEffect(() => {
    if (
      !locationId &&
      droppLocations &&
      droppLocations.length &&
      updateLocationId
    ) {
      updateLocationId(droppLocations[0])
    }
  }, [droppLocations, locationId, updateLocationId])

  const changeShippingMethod = (shippingId: string) => {
    setSelectedShippingId(shippingId)
    getLocations()
    if (updateLocationId && shippingId === droppDelMethodId) {
      updateLocationId('9ec1f30c-2564-4b73-8954-25b7b3186ed3')
    }
  }

  return (
    <>
      <CartShipmentPricingAlert shipmentPricingThreshold={shippingCost} />
      {availableShippingMethods
        ?.filter(isNotNull)
        .map((sm: any) =>
          sm.id === droppMethodId ? (
            droppLocations && (
              <CheckoutRadioCard
                key={sm.id}
                title={sm.name}
                price={
                  sm.price?.amount
                    ? `${formatNumber(sm.price?.amount)} kr.`
                    : ''
                }
                icon={<TruckLineIcon size={30} color={theme.palette.primary} />}
                description={
                  <P>{JSON.parse(sm.description)?.blocks?.[0]?.data?.text}</P>
                }
                selected={selectedShippingId === sm.id}
                onSelect={() => changeShippingMethod(sm.id)}
                showDropDown={sm.id === droppMethodId}
                options={droppLocations}
                mapDetail
                droppDelivery={sm.id === droppMethodId}
                droppDeliveryId={sm.id === droppMethodId ? sm.id : ''}
                locationId={setLocationIdInfo}
                setLocationInfo={setLocationInfo}
              />
            )
          ) : sm.id === droppDelMethodId &&
            checkout &&
            droppDeliveryLocations.includes(
              Number(checkout?.shippingAddress?.postalCode),
            ) ? (
            <CheckoutRadioCard
              key={sm.id}
              title={sm.name}
              price={
                sm.price?.amount ? `${formatNumber(sm.price?.amount)} kr.` : ''
              }
              icon={<TruckLineIcon size={30} color={theme.palette.primary} />}
              description={
                <P>{JSON.parse(sm.description)?.blocks?.[0]?.data?.text}</P>
              }
              selected={selectedShippingId === sm.id}
              onSelect={() => changeShippingMethod(sm.id)}
              options={droppLocations}
              droppDelivery={sm.id === droppDelMethodId}
              droppDeliveryId={sm.id === droppDelMethodId ? sm.id : ''}
              locationId={setLocationIdInfo}
            />
          ) : (
            <CheckoutRadioCard
              key={sm.id}
              title={sm.name}
              price={
                sm.price?.amount ? `${formatNumber(sm.price?.amount)} kr.` : ''
              }
              icon={<TruckLineIcon size={30} color={theme.palette.primary} />}
              description={
                <P>{JSON.parse(sm.description)?.blocks?.[0]?.data?.text}</P>
              }
              selected={selectedShippingId === sm.id}
              onSelect={() => changeShippingMethod(sm.id)}
            />
          ),
        )}
      <IndentWrapper>
        <DeliveryNote value={note} setValue={setNote} />
        <SpacingWrapper spacing={36}>
          <Button
            withGutter
            color="secondary"
            outlined
            loading={isLoading}
            disabled={!selectedShippingId}
            onClick={onClickNext}
          >
            Áfram
          </Button>
        </SpacingWrapper>
      </IndentWrapper>
    </>
  )
}
